<!--Blueprint and RUNTIME has this fastlink, See if they are still the same -->
<div *ngIf="(fastLinkBluePrint && fastLinkRunTime)">
  <div [ngSwitch]="CompareFastLinkPrint()">
  <div *ngSwitchCase="'offline'">
      <code class="offline">
        FL: {{ GetStation(fastLinkBluePrint.fastlinkstation) }}  {{ GetFunction(fastLinkBluePrint.status) }}
        St:    {{ GetStatus(fastLinkBluePrint.status) }}
        <br/>
      </code>
  </div>

      <div *ngSwitchCase="'online'">
      <code class="online">
        FL: {{ GetStation(fastLinkBluePrint.fastlinkstation) }}  {{ GetFunction(fastLinkBluePrint.status) }}
        St:    {{ GetStatus(fastLinkRunTime.status) }}
        <br/>
      </code>
    </div>

    <div *ngSwitchCase="'different'">
      <code class="different">
        Config Fault: FL:{{ GetStation(fastLinkBluePrint.fastlinkstation) }}
        <br/>
        B: {{ GetFunction(fastLinkBluePrint.status) }} <br/>
        F: {{ GetFunction(fastLinkRunTime.status) }}<br/>
        St: {{ GetStatus(fastLinkRunTime.status) }}
        <br/>
      </code>
  </div>

  <div *ngSwitchDefault >
          <code>
        DEFAULT :
      </code>
  </div>
  </div>
</div>

<!--Blueprint has NOT this fastlink, but RUNTIME has. So it is a newly added one -->
<div *ngIf="!fastLinkBluePrint && fastLinkRunTime">
  <div >
      <code class="added">
        Added: FL:{{ GetStation(fastLinkRunTime.fastlinkstation) }} {{ GetFunction(fastLinkRunTime.status) }}
        <br/>
      </code>
  </div>
</div>

<!--Blueprint has this fastlink, but RUNTIME has not. So it missing -->
<div *ngIf="fastLinkBluePrint && !fastLinkRunTime">
  <div >
      <code class="missing">
        Missing: FL:{{ GetStation(fastLinkBluePrint.fastlinkstation) }} {{ GetFunction(fastLinkBluePrint.status) }}
        <br/>
      </code>
  </div>
</div>
